import React, { Component } from "react";
import { Button, Container, Row, Form, Col, Offcanvas } from "react-bootstrap";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import configData from "../config.json";

import LoadingOverlay from "./LoadingOverlay";
export default class Healthmaritalstatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      loadingMessage: "Processing your request...",
      show: false,
      data: [],
      sId: sessionStorage.getItem("sessionId"),
      uId: sessionStorage.getItem("uId"),
      errors: {},
      filteredData: null,
      tableClms: [
        {
          name: "S.NO",
          selector: (row, i) => row.healthmaritalstatus_Id,
          sortable: true,
          cell: (row) => <span>{row.healthmaritalstatus_Id}</span>,
        },
        {
          name: "product id",
          selector: (row, i) => row.productid,
          sortable: true,
          cell: (row) => <span>{row.productid}</span>,
        },
        {
          name: "marital status Id",
          selector: (row, i) => row.maritalstatusId,
          sortable: true,
          cell: (row) => <span>{row.maritalstatusId}</span>,
        },
        {
          name: "marital status",
          selector: (row, i) => row.maritalstatus,
          sortable: true,
          cell: (row) => <span>{row.maritalstatus}</span>,
        },
        {
          name: "marital status code",
          selector: (row, i) => row.maritalstatuscode,
          sortable: true,
          cell: (row) => <span>{row.maritalstatuscode}</span>,
        },
        {
          name: "dummy one",
          selector: (row, i) => row.dummyone,
          sortable: true,
          cell: (row) => <span>{row.dummyone}</span>,
        },
        {
          name: "dummy two",
          selector: (row, i) => row.dummytwo,
          sortable: true,
          cell: (row) => <span>{row.dummytwo}</span>,
        },
        {
          name: "dummy three",
          selector: (row, i) => row.dummythree,
          sortable: true,
          cell: (row) => <span>{row.dummythree}</span>,
        },
        {
          name: "Actions",
          sortable: false,
          cell: (row) => (
            <div>
              {/* edit button and delete button */}
              <Button
                variant="primary"
                onClick={() => this.handleEnterEditMode(row)}
                className="bi bi-pen"
                style={{ marginRight: "3px" }}
              ></Button>
              <Button
                variant="danger"
                onClick={() => this.handleDelete(row)}
                className="bi bi-trash danger"
              ></Button>
            </div>
          ),
        },
      ],
      currentPage: 1,
      isEditing: false,
      itemsPerPage: 10,
      productid: "",
      maritalstatusId: "",
      healthmaritalstatus_Id: "",
      maritalstatus: "",
      maritalstatuscode: "",
      dummyone: "",
      dummytwo: "",
      dummythree: "",
    };
  }
  // offcanvas Open
  handleOffcanvasShow = () => {
    this.setState({
      show: true,
      productid: "",
      maritalstatusId: "",
      healthmaritalstatus_Id: "",
      maritalstatus: "",
      maritalstatuscode: "",
      dummyone: "",
      dummytwo: "",
      dummythree: "",
    });
  };
  // Offcanvas close button
  handleOffcanvasClose = () => {
    this.setState({ show: false });
  };
  showToast = (msg, type) => {
    var tType = toast.TYPE.INFO;
    if (type === "success") tType = toast.TYPE.SUCCESS;
    if (type === "error") tType = toast.TYPE.ERROR;
    if (type === "warning") tType = toast.TYPE.WARNING;
    toast(msg, { type: tType });
  };
  HealthmaritalstatuseditHandler = (e) => {
    e.preventDefault();
    // const updateFormData = {...editFormData};
    // updateFormData['Healthmaritalstatus_Id'] = e.target.parentElement.getAttribute("id");
    // setEditFormData(updateFormData);
    // setEdit(true);
  };

  HealthmaritalstatusfetchHandler = () => {
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Healthmaritalstatus/list", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === "success") {
          this.setState({ data: data.list });
        }
      });
  };
  // Update
  hMupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append(
      "healthmaritalstatus_Id",
      this.state.healthmaritalstatus_Id
    );
    formData.append("productid", this.state.productid);
    formData.append("maritalstatusId", this.state.maritalstatusId);
    formData.append("maritalstatus", this.state.maritalstatus);
    formData.append("maritalstatuscode", this.state.maritalstatuscode);
    formData.append("dummyone", this.state.dummyone);
    formData.append("dummytwo", this.state.dummytwo);
    formData.append("dummythree", this.state.dummythree);

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Healthmaritalstatus/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthmaritalstatusfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            productid: "",
            maritalstatus: "",
            maritalstatusId: "",
            maritalstatuscode: "",
            dummyone: "",
            dummytwo: "",
            dummythree: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  HealthmaritalstatussubmitHandler = (e) => {
    e.preventDefault();
    //   setButtons(contacts);
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("productid", this.state.productid);
    formData.append("maritalstatusId", this.state.maritalstatusId);
    formData.append("maritalstatus", this.state.maritalstatus);
    formData.append("maritalstatuscode", this.state.maritalstatuscode);
    formData.append("dummyone", this.state.dummyone);
    formData.append("dummytwo", this.state.dummytwo);
    formData.append("dummythree", this.state.dummythree);

    this.setState({ loading: true, loadingMessage: "Saving..." });
    fetch(configData.api_url + "C_Healthmaritalstatus/add", {
      // Enter your IP address here

      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthmaritalstatusfetchHandler();
          this.handleOffcanvasClose();
          this.setState({
            productid: "",
            maritalstatusId: "",
            maritalstatus: "",
            maritalstatuscode: "",
            dummyone: "",
            dummytwo: "",
            dummythree: "",
          });
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  HealthmaritalstatusupdateHandler = (e) => {
    e.preventDefault();
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    formData.append("productid", this.state.productid);
    formData.append("maritalstatusId", this.state.maritalstatusId);
    formData.append("maritalstatus", this.state.maritalstatus);
    formData.append("maritalstatuscode", this.state.maritalstatuscode);
    formData.append("dummyone", this.state.dummyone);
    formData.append("dummytwo", this.state.dummytwo);
    formData.append("dummythree", this.state.dummythree);

    this.setState({ loading: true, loadingMessage: "Updating..." });
    fetch(configData.api_url + "C_Healthmaritalstatus/update", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthmaritalstatusfetchHandler();
          this.handleOffcanvasClose();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };

  componentDidMount() {
    this.HealthmaritalstatusfetchHandler();
  }
  handleproductidChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ productid: fieldValue });
  };
  handlemaritalstatusIdChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maritalstatusId: fieldValue });
  };
  handlemaritalstatusChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maritalstatus: fieldValue });
  };
  handlemaritalstatuscodeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ maritalstatuscode: fieldValue });
  };
  handledummyoneChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummyone: fieldValue });
  };
  handledummytwoChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummytwo: fieldValue });
  };
  handledummythreeChange = (e) => {
    e.preventDefault();
    const fieldValue = e.target.value;
    this.setState({ dummythree: fieldValue });
  };
  handleRowSelect = (row) => {
    this.setState({
      selectedRow: row.index,
    });
  };
  handleRowUpdate = (newData, oldData) => {
    const data = [...this.state.data];
    const index = oldData.index;
    data[index] = newData;
    this.setState({ data });
  };
  // Edit functionality
  handleEnterEditMode = (row) => {
    // this.setState({ cData: { ...row }, isEditing: true });
    var formData = new FormData();
    formData.append("sId", this.state.sId);
    formData.append("uId", this.state.uId);
    fetch(configData.api_url + "C_Healthmaritalstatus/list", {
      // Enter your IP address here
      method: "POST",
      //headers :{ 'Content-Type' : 'application/json'},
      mode: "cors",
      body: formData, // body data type must match "Content-Type" header
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.setState({
            healthmaritalstatus_Id: row.healthmaritalstatus_Id,
            productid: row.productid,
            maritalstatusId: row.maritalstatusId,
            maritalstatus: row.maritalstatus,
            maritalstatuscode: row.maritalstatuscode,
            dummyone: row.dummyone,
            dummytwo: row.dummytwo,
            dummythree: row.dummythree,

            isEditing: true,
          });
        }
      });
  };

  handleEdit = (row) => {
    console.log(`Editing row with ID ${row.id}`);
    // implement your edit logic here
  };
  handleDelete = (row, index) => {
    var formData = new FormData();
    formData.append("healthmaritalstatus_Id", row.healthmaritalstatus_Id);
    this.setState({ loading: true, loadingMessage: "Deleting..." });
    fetch(configData.api_url + "C_Healthmaritalstatus/delete", {
      method: "POST",
      mode: "cors",
      body: formData,
    })
      .then((response) => response.json())
      .then((data) => {
        this.showToast(data.message, data.status);
        if (data.status === "success") {
          this.HealthmaritalstatusfetchHandler();
        }
      
        this.setState({ loading: false });})
    .catch(() => { this.setState({ loading: false }); });
  };
  handlePageChange = (page) => {
    this.setState({ currentPage: page });
  };

  handlePerRowsChange = (newPerPage, page) => {
    this.setState({ itemsPerPage: newPerPage, currentPage: page });
  };

  handleFilter = (e) => {
    const searchValue = e.target.value.toLowerCase();
    const filteredData = this.state.data.filter((row) => {
      return Object.values(row).join(" ").toLowerCase().includes(searchValue);
    });
    this.setState({ filteredData });
  };

  render() {
    const paginatedData = this.state.filteredData
      ? this.state.filteredData.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      )
      : this.state.data.slice(
        (this.state.currentPage - 1) * this.state.itemsPerPage,
        this.state.currentPage * this.state.itemsPerPage
      );

    return (
      <div className="page-title">
        <LoadingOverlay show={this.state.loading} message={this.state.loadingMessage} />
        <div className="row">
          <div className="title_left">
            <h2 style={{ textAlign: "start" }}>Health Marital Status</h2>
          </div>
          <div className="col-md-12 col-sm-12 col-xs-12">
            <div className="x_panel">
              <div className="x_content">
                <div
                  id="datatable_wrapper"
                  className="dataTables_wrapper form-inline
                                   dt-bootstrap no-footer"
                >
                  <Row className="row">
                    <Col
                      className="d-flex justify-content-end"
                      style={{ marginRight: "5px", marginTop: "20px" }}
                    >
                      <Button
                        variant="primary"
                        className="bi bi-plus "
                        onClick={this.handleOffcanvasShow}
                      >
                        New
                      </Button>
                      <Offcanvas
                        show={this.state.show}
                        onHide={this.handleOffcanvasClose}
                        {...this.props}
                        style={{ width: "500px" }}
                        placement="end"
                        backdrop="true"
                      >
                        <Offcanvas.Header closeButton>
                          <Offcanvas.Title>
                            Health Marital Status page
                          </Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                          <Container
                            style={{ overflowY: "auto", height: "auto" }}
                          >
                            <Row className="divstyle">
                              <Row>
                                <Form>
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        product id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handleproductidChange}
                                        className="form-control"
                                        name="productid"
                                        value={this.state.productid}
                                        required="required"
                                        placeholder="Enter productid"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.productid}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        marital status Id
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlemaritalstatusIdChange
                                        }
                                        className="form-control"
                                        name="maritalstatusId"
                                        value={this.state.maritalstatusId}
                                        required="required"
                                        placeholder="Enter maritalstatusId"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.maritalstatusId}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        marital status
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlemaritalstatusChange
                                        }
                                        className="form-control"
                                        name="maritalstatus"
                                        value={this.state.maritalstatus}
                                        required="required"
                                        placeholder="Enter maritalstatus"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.maritalstatus}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        marital status code
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={
                                          this.handlemaritalstatuscodeChange
                                        }
                                        className="form-control"
                                        name="maritalstatuscode"
                                        value={this.state.maritalstatuscode}
                                        required="required"
                                        placeholder="Enter maritalstatuscode"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.maritalstatuscode}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        dummy one
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummyoneChange}
                                        className="form-control"
                                        name="dummyone"
                                        value={this.state.dummyone}
                                        required="required"
                                        placeholder="Enter dummyone"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummyone}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        dummy two
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummytwoChange}
                                        className="form-control"
                                        name="dummytwo"
                                        value={this.state.dummytwo}
                                        required="required"
                                        placeholder="Enter dummytwo"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummytwo}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                  <Row>
                                    <Col lg="4" md="4">
                                      <Form.Label style={{ paddingTop: "8px" }}>
                                        dummy three
                                      </Form.Label>
                                    </Col>
                                    <Col lg="8" md="8">
                                      <Form.Control
                                        type="text"
                                        onChange={this.handledummythreeChange}
                                        className="form-control"
                                        name="dummythree"
                                        value={this.state.dummythree}
                                        required="required"
                                        placeholder="Enter dummythree"
                                      />
                                    </Col>
                                    <div
                                      className="errorMsg"
                                      style={{ color: "red" }}
                                    >
                                      {" "}
                                      {this.state.errors.dummythree}{" "}
                                    </div>
                                  </Row>
                                  <br />
                                </Form>
                              </Row>
                            </Row>
                            <Row>
                              <Col
                                className="d-flex justify-content-end"
                                style={{ marginRight: "50px" }}
                              >
                                <Button
                                  className="button"
                                  variant="success"
                                  onClick={
                                    this.HealthmaritalstatussubmitHandler
                                  }
                                  style={{
                                    marginTop: "20px",
                                  }}
                                >
                                  Save
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                        </Offcanvas.Body>
                      </Offcanvas>
                      {/*offcanvas is over */}
                      <div>
                        {/* edit off canvas start here */}
                        {this.state.isEditing && (
                          <Offcanvas
                            show={this.state.isEditing}
                            onHide={() => this.setState({ isEditing: false })}
                            {...this.props}
                            style={{ width: "500px" }}
                            placement="end"
                            backdrop="true"
                          >
                            <Offcanvas.Header closeButton>
                              <Offcanvas.Title>
                                Health Marital Status Editing
                              </Offcanvas.Title>
                            </Offcanvas.Header>
                            <Offcanvas.Body>
                              <Container
                                style={{ overflowY: "auto", height: "auto" }}
                              >
                                <Row className="divstyle">
                                  <Row>
                                    <Form>
                                      <Row>
                                        <Col lg="4" md="4">
                                          <Form.Label
                                            style={{ paddingTop: "8px" }}
                                          >
                                            product id
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Control
                                            type="text"
                                            onChange={
                                              this.handleproductidChange
                                            }
                                            className="form-control"
                                            name="productid"
                                            value={this.state.productid}
                                            required="required"
                                            placeholder="Enter productid"
                                          />
                                        </Col>
                                        <div
                                          className="errorMsg"
                                          style={{ color: "red" }}
                                        >
                                          {this.state.errors.productid}{" "}
                                        </div>
                                      </Row>
                                      <br />
                                      <Row>
                                        <Col lg="4" md="4">
                                          <Form.Label
                                            style={{ paddingTop: "8px" }}
                                          >
                                            marital status Id
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Control
                                            type="text"
                                            onChange={
                                              this.handlemaritalstatusIdChange
                                            }
                                            className="form-control"
                                            name="maritalstatusId"
                                            value={this.state.maritalstatusId}
                                            required="required"
                                            placeholder="Enter maritalstatusId"
                                          />
                                        </Col>
                                        <div
                                          className="errorMsg"
                                          style={{ color: "red" }}
                                        >
                                          {" "}
                                          {
                                            this.state.errors.maritalstatusId
                                          }{" "}
                                        </div>
                                      </Row>
                                      <br />
                                      <Row>
                                        <Col lg="4" md="4">
                                          <Form.Label
                                            style={{ paddingTop: "8px" }}
                                          >
                                            marital status
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Control
                                            type="text"
                                            onChange={
                                              this.handlemaritalstatusChange
                                            }
                                            className="form-control"
                                            name="maritalstatus"
                                            value={this.state.maritalstatus}
                                            required="required"
                                            placeholder="Enter maritalstatus"
                                          />
                                        </Col>
                                        <div
                                          className="errorMsg"
                                          style={{ color: "red" }}
                                        >
                                          {" "}
                                          {this.state.errors.maritalstatus}{" "}
                                        </div>
                                      </Row>
                                      <br />
                                      <Row>
                                        <Col lg="4" md="4">
                                          <Form.Label
                                            style={{ paddingTop: "8px" }}
                                          >
                                            marital status code
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Control
                                            type="text"
                                            onChange={
                                              this.handlemaritalstatuscodeChange
                                            }
                                            className="form-control"
                                            name="maritalstatuscode"
                                            value={this.state.maritalstatuscode}
                                            required="required"
                                            placeholder="Enter maritalstatuscode"
                                          />
                                        </Col>
                                        <div
                                          className="errorMsg"
                                          style={{ color: "red" }}
                                        >
                                          {" "}
                                          {
                                            this.state.errors.maritalstatuscode
                                          }{" "}
                                        </div>
                                      </Row>
                                      <br />
                                      <Row>
                                        <Col lg="4" md="4">
                                          <Form.Label
                                            style={{ paddingTop: "8px" }}
                                          >
                                            dummy one
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Control
                                            type="text"
                                            onChange={this.handledummyoneChange}
                                            className="form-control"
                                            name="dummyone"
                                            value={this.state.dummyone}
                                            required="required"
                                            placeholder="Enter dummyone"
                                          />
                                        </Col>
                                        <div
                                          className="errorMsg"
                                          style={{ color: "red" }}
                                        >
                                          {" "}
                                          {this.state.errors.dummyone}{" "}
                                        </div>
                                      </Row>
                                      <br />
                                      <Row>
                                        <Col lg="4" md="4">
                                          <Form.Label
                                            style={{ paddingTop: "8px" }}
                                          >
                                            dummy two
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Control
                                            type="text"
                                            onChange={this.handledummytwoChange}
                                            className="form-control"
                                            name="dummytwo"
                                            value={this.state.dummytwo}
                                            required="required"
                                            placeholder="Enter dummytwo"
                                          />
                                        </Col>
                                        <div
                                          className="errorMsg"
                                          style={{ color: "red" }}
                                        >
                                          {" "}
                                          {this.state.errors.dummytwo}{" "}
                                        </div>
                                      </Row>
                                      <br />
                                      <Row>
                                        <Col lg="4" md="4">
                                          <Form.Label
                                            style={{ paddingTop: "8px" }}
                                          >
                                            dummy three
                                          </Form.Label>
                                        </Col>
                                        <Col lg="8" md="8">
                                          <Form.Control
                                            type="text"
                                            onChange={
                                              this.handledummythreeChange
                                            }
                                            className="form-control"
                                            name="dummythree"
                                            value={this.state.dummythree}
                                            required="required"
                                            placeholder="Enter dummythree"
                                          />
                                        </Col>
                                        <div
                                          className="errorMsg"
                                          style={{ color: "red" }}
                                        >
                                          {" "}
                                          {this.state.errors.dummythree}{" "}
                                        </div>
                                      </Row>
                                      <br />
                                    </Form>
                                  </Row>
                                </Row>
                                <Row>
                                  <Col
                                    className="d-flex justify-content-end"
                                    style={{ marginRight: "50px" }}
                                  >
                                    <Button
                                      className="button"
                                      variant="success"
                                      onClick={this.hMupdateHandler}
                                      style={{
                                        marginTop: "20px",
                                      }}
                                    >
                                      Update
                                    </Button>
                                  </Col>
                                </Row>
                              </Container>
                            </Offcanvas.Body>
                          </Offcanvas>
                        )}
                      </div>
                    </Col>
                  </Row>
                  <br />
                  <Row>
                    <div style={{ marginRight: "5px" }}>
                      {/* searchbar,pagination,filter */}
                      <input
                        type="text"
                        style={{ float: "left", marginBottom: "10px" }}
                        onChange={this.handleFilter}
                        placeholder="Search..."
                      />
                      <DataTable
                        data={paginatedData}
                        columns={this.state.tableClms}
                        pagination
                        paginationServer
                        paginationTotalRows={
                          this.state.filteredData
                            ? this.state.filteredData.length
                            : this.state.data.length
                        }
                        paginationRowsPerPageOptions={[
                          10, 20, 30, 50, 60, 70, 80, 90, 100,
                        ]}
                        onChangeRowsPerPage={this.handlePerRowsChange}
                        onChangePage={this.handlePageChange}
                        paginationRowsPerPageOptions={[100, 200, 300, 400, 500, 600, 700, 800, 900, 1000]}
                        paginationPerPage={100}
                        keyField="id"
                        className="table table-striped table-bordered dataTable no-footer employeesTableIcons"
                      />
                    </div>
                  </Row>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
